import { colors } from '@fs/zion-ui'

export const coreFlavors = {
  mango: {
    start: '#F87F09', // yellow30
    end: '#D5349A', // red50
  },
  blueberry: {
    start: '#D5349A', // red50
    end: '#00ABEC', // blue30
  },
  apple: {
    start: '#00ABEC', // blue30
    end: '#5AB452', // green30
  },
  dusk: {
    start: '#00B59A', // teal30
    end: '#9E55DD', // purple50
  },
  sunset: {
    start: '#4DB3D5',
    middle: '#D37AA8',
    end: '#FF6699',
  },
  fire: {
    start: '#FFCC66',
    end: '#EF614C',
  },
  sunrise: {
    start: '#99DEDF',
    end: '#FFCC66',
  },
  lava: {
    start: '#FF82B2',
    end: '#EE2541',
  },
  seafoam: {
    start: '#00EBC8',
    end: '#029DF4',
  },
}

const gradient = {
  degree: '135deg',
  start: '8%',
  middle: '50%',
  end: '92%',
}

// Any changes made to the solid values must be done as well in Brightspot.
const flavors = {
  default: 'seafoam',
  mango: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.mango.start} ${gradient.start}, ${coreFlavors.mango.end} ${gradient.end})`,
    solid: coreFlavors.mango.start,
    filmedGradient: `linear-gradient(90deg, ${coreFlavors.mango.start} 0%, ${coreFlavors.mango.end}00 100%)`,
    textColor: colors.gray00,
  },
  blueberry: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.blueberry.start} ${gradient.start}, ${coreFlavors.blueberry.end} ${gradient.end})`,
    solid: coreFlavors.blueberry.start,
    filmedGradient: `linear-gradient(90deg, ${coreFlavors.blueberry.start} 0%, ${coreFlavors.blueberry.end}00 100%)`,
    textColor: colors.gray100,
  },
  apple: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.apple.start} ${gradient.start}, ${coreFlavors.apple.end} ${gradient.end})`,
    solid: coreFlavors.apple.end,
    filmedGradient: `linear-gradient(90deg, ${coreFlavors.apple.start} 0%, ${coreFlavors.apple.end}00 100%)`,
    textColor: colors.gray00,
  },
  dusk: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.dusk.start} ${gradient.start}, ${coreFlavors.dusk.end} ${gradient.end})`,
    solid: coreFlavors.dusk.end,
    filmedGradient: `linear-gradient(90deg, ${coreFlavors.dusk.start} 0%, ${coreFlavors.dusk.end}00 100%)`,
    textColor: colors.gray00,
  },
  sunset: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.sunset.start} ${gradient.start}, ${coreFlavors.sunset.middle} ${gradient.middle}, ${coreFlavors.sunset.end} ${gradient.end})`,
    solid: coreFlavors.sunset.end,
    filmedGradient: 'linear-gradient(90deg, #4FCCB8 0%, #D37AA8 50% #FF669900 100%)',
    textColor: colors.gray00,
  },
  fire: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.fire.start} ${gradient.start}, ${coreFlavors.fire.end} ${gradient.end})`,
    solid: coreFlavors.fire.end,
    filmedGradient: 'linear-gradient(90deg, #FFCC66 0%, #EF614C00 100%)',
    textColor: colors.gray00,
  },
  sunrise: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.sunrise.start} ${gradient.start}, ${coreFlavors.sunrise.end} ${gradient.end})`,
    solid: coreFlavors.sunrise.end,
    filmedGradient: 'linear-gradient(90deg, #FFCC66 0%, #EF614C00 100%)',
    textColor: colors.gray00,
  },
  lava: {
    gradient: `linear-gradient(${gradient.degree}, ${coreFlavors.lava.start} ${gradient.start}, ${coreFlavors.lava.end} ${gradient.end})`,
    solid: coreFlavors.lava.end,
    filmedGradient: 'linear-gradient(90deg, #FF82B2 0%, #EE254100 100%)',
    textColor: colors.gray00,
  },
  seafoam: {
    gradient: `linear-gradient(90deg, ${coreFlavors.seafoam.start} ${gradient.start}, ${coreFlavors.seafoam.end} ${gradient.end})`,
    solid: coreFlavors.seafoam.end,
    filmedGradient: 'linear-gradient(90deg, #00EBC8 0%, #029DF400 100%)',
    textColor: colors.gray00,
  },
  charcoal: {
    gradient: 'linear-gradient(0deg, #252525cc 30%, transparent 100%)',
    solid: colors.gray02,
    filmedGradient: 'linear-gradient(90deg, #252525 30%, #25252535 100%)',
    textColor: colors.gray100,
  },
  smoke: {
    gradient: 'linear-gradient(0deg, #252525cc 0%, transparent 55%)',
    solid: '#252525',
    filmedGradient: 'linear-gradient(90deg, #252525 30%, #25252535 100%)',
  },
  flavorless: {
    gradient: 'linear-gradient(135deg, transparent, transparent)',
    solid: 'transparent',
    filmedGradient: 'linear-gradient(90deg, transparent, transparent)',
  },
  none: {
    gradient: 'linear-gradient(135deg, #ffffff, #ffffff)',
    solid: '#ffffff',
    filmedGradient: 'linear-gradient(90deg, #ffffff, #ffffff)',
  },
  // platinum sponsors
  familysearch: {
    gradient: 'linear-gradient(90deg, #355800 8%, #86ba41 92%)',
    solid: '#64BC55',
  },
  ancestry: {
    gradient: 'linear-gradient(90deg, #202122 8%, #353637 92%)',
    solid: '#252525',
  },
  myheritage: {
    gradient: 'linear-gradient(90deg, #892f00 0%, #e46e31 100%)',
    solid: '#EF614C',
  },
  storied: {
    solid: '#EE2541',
  },
  // Sponsor table
  platinum: {
    solid: colors.gray90,
  },
  gold: {
    solid: colors.yellow80,
  },
  silver: {
    solid: colors.gray70,
  },
  bronze: {
    solid: colors.yellow60,
  },
  society: {
    solid: colors.blue80,
  },
  // Authorization Badges
  pending: {
    solid: colors.blue80,
  },
  approved: {
    solid: colors.green80,
  },
  declined: {
    solid: colors.red70,
  },
  accepted: {
    solid: colors.green40,
    textColor: colors.gray100,
  },
  // Badges
  online: {
    solid: colors.green40,
    textColor: colors.gray100,
  },
  beginner: {
    solid: colors.blue80,
  },
  intermediate: {
    solid: colors.red70,
  },
  advanced: {
    solid: colors.purple70,
  },
  alllevels: {
    solid: colors.gray80,
  },
  draft: {
    solid: colors.yellow70,
    textColor: colors.gray00,
  },
  submitted: {
    solid: colors.green60,
    textColor: colors.gray00,
  },
  // Video Tracking Dashboard status lozenges - exact hex pulled from Figma (file
  // smts2b36HyiXXdczoMZBKM, node 1338:8647). These are Figma-only "Zion/<Color>/<N>" variables
  // that do NOT correspond to the colors.<name> tokens above (that scale runs light->dark as the
  // number increases; the Figma file's scale runs the opposite direction), so they're hardcoded here.
  // textColor is a fixed hex (Figma's bound "gray00" variable), not a colors.grayNN token - those
  // tokens flip per theme (colors.gray100 is dark in day mode but goes near-white in night mode),
  // and the Figma spec calls for these lozenges to always render with dark text, even in dark mode.
  videoProcessingCompleted: {
    solid: '#C9D858',
    textColor: '#100f0e',
  },
  videoProcessingInProgress: {
    solid: '#F9C83F',
    textColor: '#100f0e',
  },
  videoProcessingPending: {
    solid: '#8ADBED',
    textColor: '#100f0e',
  },
  videoProcessingNotStarted: {
    solid: '#CFCECE',
    textColor: '#100f0e',
  },
  videoProcessingError: {
    solid: '#FC96A9',
    textColor: '#100f0e',
  },
  // Misc
  alert: {
    solid: colors.yellow70,
  },
  gray: {
    solid: colors.gray10,
    gradient: 'linear-gradient(90deg, rgba(255, 240, 235, 0.196), rgba(255, 240, 235, 0.196))',
    filmedGradient: 'linear-gradient(90deg, rgba(255, 240, 235, 0.196), rgba(255, 240, 235, 0.196))',
  },
}
const validFlavors = Object.keys(flavors)
const scrimGradient = 'linear-gradient(90deg, #0000008c, 29.69%, transparent 70%)'

export { flavors, validFlavors, scrimGradient }
